import client, { getResponseData } from './client';
export const getFiles = (appId, params) => {
	return client({
		url: '/knowledge-base',
		method: 'get',
		params,
		headers: {
			ApplicationID: appId,
		},
	}).then((res) => getResponseData(res));
};

export const uploadFiles = (appId, files, sbus, progressCallback) => {
	const formData = new FormData();
	files.forEach((file) => {
		formData.append('files', file.originFileObj);
	});

	sbus.forEach((sbu) => {
		formData.append('sbu', sbu);
	});

	return client({
		url: '/knowledge-base',
		method: 'post',
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data',
			ApplicationID: appId,
		},
		onUploadProgress: progressCallback || function () {},
	});
};

export const deleteFiles = (appId, ossKeys) => {
	const data = {
		ossKeys,
	};
	return client({
		url: '/knowledge-base',
		method: 'delete',
		headers: {
			ApplicationID: appId,
		},
		data,
	}).then((response) => {
		const resData = getResponseData(response);
		if (resData.errorCount > 0) {
			return Promise.reject(false);
		} else {
			return Promise.resolve(resData);
		}
	});
};

export const approveFile = (appId, ossKey) => {
	const data = {
		ossKey,
	};
	return client({
		url: '/knowledge-base/approve',
		method: 'patch',
		headers: {
			ApplicationID: appId,
		},
		data,
	});
};

export const previewFile = (appId, ossKey) => {
	const params = {
		ossKey,
	};
	return client({
		url: '/knowledge-base/view',
		method: 'get',
		responseType: 'blob',
		headers: {
			ApplicationID: appId,
		},
		params,
	});
};
